import {useQuery} from "@apollo/client";
import {UNIQUE_PRODUCT} from "../productTypeDefs";

export const useQueryUniqueProduct = (options?: any): any => (
  useQuery(UNIQUE_PRODUCT, options)
);
